module.exports = __webpack_public_path__ + "static/img/index-menu-7.9f149c9c.png";